/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_1_RoleInputs */

const en_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human review controls`)
};

const de_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-Datenschutz durch Design`)
};

const fr_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialite par conception`)
};

const es_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad por diseño`)
};

const it_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy per architettura`)
};

const nl_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy door architectuur`)
};

const pl_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatnosc w architekturze`)
};

const fi_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyys arkkitehtuurissa`)
};

const da_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatliv gennem arkitektur`)
};

const sv_landing_testimonial_1_role = /** @type {(inputs: Landing_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritet genom arkitektur`)
};

/**
* | output |
* | --- |
* | "Human review controls" |
*
* @param {Landing_Testimonial_1_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_1_role = /** @type {((inputs?: Landing_Testimonial_1_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_1_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_1_role(inputs)
	if (locale === "fr") return fr_landing_testimonial_1_role(inputs)
	if (locale === "es") return es_landing_testimonial_1_role(inputs)
	if (locale === "it") return it_landing_testimonial_1_role(inputs)
	if (locale === "nl") return nl_landing_testimonial_1_role(inputs)
	if (locale === "pl") return pl_landing_testimonial_1_role(inputs)
	if (locale === "fi") return fi_landing_testimonial_1_role(inputs)
	if (locale === "da") return da_landing_testimonial_1_role(inputs)
	if (locale === "sv") return sv_landing_testimonial_1_role(inputs)
	return en_landing_testimonial_1_role(inputs)
});